import { CookiesView } from '../views';
export default CookiesView;
